// @flow
import { RESORT_PRICE_REMOTE } from 'Client/cms/toolkit/constants';
import { ProductPriceRemoteLine } from 'Components/lines/product-price-remote-line/ProductPriceRemoteLine';
import { productPriceRemoteResolver } from './productPriceRemote.resolver';

export const productPriceRemoteDescriptor = {
  name: RESORT_PRICE_REMOTE,
  component: ProductPriceRemoteLine,
  resolve: productPriceRemoteResolver.resolve,
};
